<template>
  <v-list subheader>
    <v-subheader>
      <v-icon class="padded-icon pr-2">{{ icon }}</v-icon>
      {{ header }}
    </v-subheader>
    <div v-if="loading">
      <v-icon>refresh</v-icon>
    </div>

    <transition-group name="slide-y-reverse-transition" tag="div">
      <v-list-tile avatar v-for="addon in addons" :key="addon.id" @click=""
                   :to="{ name: 'addon', params: { id: addon.id }}">
        <v-list-tile-avatar>
          <img v-bind:src="addon.icon ? addon.icon : '/static/img/icons/manager/icon.png'"/>
        </v-list-tile-avatar>
        <v-list-tile-content>
          <v-list-tile-title v-html="addon.name"/>
          <v-list-tile-sub-title> {{ addon.description.short }}</v-list-tile-sub-title>
        </v-list-tile-content>
        <v-list-tile-action>
          <!--<v-icon v-bind:color="item.active ? 'teal' : 'grey'">chat_bubble</v-icon>-->
        </v-list-tile-action>
      </v-list-tile>
    </transition-group>

    <div v-if="addons.length === 0 && !loading">
      No addons found.
    </div>
  </v-list>
</template>

<script>

  export default {
    props: [ 'addons', 'header', 'icon', 'loading' ],
    name: 'PluginList',
  };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/plugin-list/PluginList.vue